// Components
import { RootState } from '../index';

const getActiveSessions = (state: RootState) => state.activeSessionsDataSlice.active_sessions;

export { getActiveSessions };
